module.exports = __webpack_public_path__ + "static/media/rating-star-full.eaa4e6c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/rating-star-full.svg
// module id = 744
// module chunks = 0